import * as React from "react";
import { Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpArrayMultilineString } from "../../../gvc/testNewForm/CpArrayMultilineString";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";

interface Props {
  index: number;
}
export const WorkloadContainerHooks: React.FC<Props> = React.memo(({ index }) => {
  const postStartIsConfigured = useCpFormValue(`containers.${index}.lifecycle.postStart.exec.isConfigured`);
  const preStopIsConfigured = useCpFormValue(`containers.${index}.lifecycle.preStop.exec.isConfigured`);

  return (
    <>
      <Divider orientation={`left`} orientationMargin={0}>
        Lifecycle Hooks - Post Start Hook
      </Divider>
      <CpFormItem>
        <div className="flex items-center gap-2">
          <CpLabel name={`containers.${index}.lifecycle.postStart.exec.isConfigured`}>
            Enable Post Start Hook
            <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
              <CpLabelDirtyIndicator name={`containers.${index}.lifecycle.postStart.exec.isConfigured`} />
            </Only>
          </CpLabel>
          <CpSwitch name={`containers.${index}.lifecycle.postStart.exec.isConfigured`} />
        </div>
      </CpFormItem>
      {postStartIsConfigured ? (
        <>
          <CpFormItem>
            <CpLabel name={`containers.${index}.lifecycle.postStart.exec.command`}>
              Command
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.lifecycle.postStart.exec.command`} />
              </Only>
            </CpLabel>
            <CpInput name={`containers.${index}.lifecycle.postStart.exec.command`} style={{ width: 600 }} />
          </CpFormItem>
          <div style={{ maxWidth: 600 }}>
            <CpArrayMultilineString
              label="Args"
              name={`containers.${index}.lifecycle.postStart.exec.args`}
              dirtyIndicator={{
                isEnabled: true,
                only: {
                  name: "meta.isCreate",
                  checkFn: (v) => v === false,
                },
              }}
            />
          </div>
        </>
      ) : null}
      <Divider orientation={`left`} orientationMargin={0}>
        Lifecycle Hooks - Pre Stop Hook
      </Divider>
      <CpFormItem>
        <div className="flex items-center gap-2">
          <CpLabel name={`containers.${index}.lifecycle.preStop.exec.isConfigured`}>
            Enable Pre Stop Hook
            <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
              <CpLabelDirtyIndicator name={`containers.${index}.lifecycle.preStop.exec.isConfigured`} />
            </Only>
          </CpLabel>
          <CpSwitch name={`containers.${index}.lifecycle.preStop.exec.isConfigured`} />
        </div>
      </CpFormItem>
      {preStopIsConfigured ? (
        <>
          <CpFormItem>
            <CpLabel name={`containers.${index}.lifecycle.preStop.exec.command`}>
              Command
              <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                <CpLabelDirtyIndicator name={`containers.${index}.lifecycle.preStop.exec.command`} />
              </Only>
            </CpLabel>
            <CpInput name={`containers.${index}.lifecycle.preStop.exec.command`} style={{ width: 600 }} />
          </CpFormItem>
          <div style={{ maxWidth: 600 }}>
            <CpArrayMultilineString
              label="Args"
              name={`containers.${index}.lifecycle.preStop.exec.args`}
              dirtyIndicator={{
                isEnabled: true,
                only: {
                  name: "meta.isCreate",
                  checkFn: (v) => v === false,
                },
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
});
